// ********************************************************
// Filters
// Definitions of some commen filters.
// The filters are generel resuable as filters via Vue mixin.
// ********************************************************

import * as DateUtil from '@/core/date'

export default {
  filters: {
    asDate: function (date) {
      return DateUtil.getSmartDate(date)
    }
  }
}
